import { SgdfNavBarItem } from './NavBarItem.js';
window.customElements.define('sgdf-navbar-item', SgdfNavBarItem);
//# sourceMappingURL=sgdf-navbar-item.js.map